import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import FileSaver from 'file-saver';
import createAboPaths from './abo-paths';

jQuery(function()
{
    var { Promise } = window;

    if (!Promise)
    {
        ({ Promise } = JSZip.external);
    }

    /**
	 * show a successful message.
	 * @param {String} text the text to show.
	 */
    function showMessage(text)
    {
        jQuery('#result')
            .addClass('alert alert-success')
            .text(text);
    }

    /**
	 * show an error message.
	 * @param {String} text the text to show.
	 */
    function showError(text)
    {
        jQuery('#result')
            .addClass('alert alert-danger')
            .text(text);
    }

    /**
	 * Fetch the content and return the associated promise.
	 * @param {String} url the url of the content to fetch.
	 * @return {Promise} the promise containing the data.
	 */
    function urlToPromise(url)
    {
        return new Promise(function(resolve, reject)
        {
            JSZipUtils.getBinaryContent(url, function(err, data)
            {
                if (err)
                {
                    reject(err);
                }
                else
                {
                    resolve(data);
                }
            });
        });
    }

    if (!JSZip.support.blob)
    {
        showError('This demo works only with a recent browser !');
        return;
    }

    function init()
    {
        handleImageSrcs();
    }

    function handleImageSrcs()
    {
        document.querySelectorAll('#client-side-zip-image-list .product-downloads__item picture').forEach(item =>
        {
            const originalSrc = item.getAttribute('data-src');
            const targetSrc = originalSrc.replace('product-main-image', 'product-list-image');

            const aboPaths = createAboPaths(targetSrc);

            item.querySelector('img').setAttribute('src', aboPaths.original);
            item.querySelector('source[type="image/avif"]')
                .setAttribute('srcset', aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x');
            item.querySelector('source[type="image/webp"]')
                .setAttribute('srcset', aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x');
            item.querySelector('source[type="image/jpeg"]')
                .setAttribute('srcset', aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x');
        });
    }

    jQuery('.client-side-zip-image-download').on('click', function( event )
    {
        event.preventDefault();
        var zip = new JSZip();

        // find every image list item
        jQuery('#client-side-zip-image-list').find('.client-side-zip-image-list-item')
            .each(function()
            {
                var url = jQuery(this).attr('href');
                var filename = url.replace(/.*\//g, '');

                zip.file(filename, urlToPromise(url), { binary: true });
            });

        // when everything has been downloaded, we can trigger the dl
        zip.generateAsync(
            { type: 'blob' }
        ).then(function callback(blob)
        {
            let productNumber = $('#shoppinglist-overlay-data').data('productnumber');

            // see FileSaver.js
            FileSaver.saveAs(blob, productNumber + '_images.zip');
            showMessage('done !');
        }, function(e)
        {
            showError(e);
        });

        return false;
    });

    init();
});
